var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTypeleftDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.513 20.06h.75v-1.5H6.5L19.47 5.591l.53-.53L18.94 4l-.531.53-12.97 12.971V6.736h-1.5V20.06h12.574Z"
})));
export { SvgTypeleftDown as ReactComponent };
export default __webpack_public_path__ + "3dc6fc79e1fa2bdb53f534a713388587.svg";